module.exports = __webpack_public_path__ + "img/4.c5961d84.png";